import React from 'react';

const Contact = () => {
  const contactInfo = [
    {
      icon: "📍",
      title: "Location",
      content: "Mruma street, nearby Msigani Luxury\nMSIGANI ward, Ubungo District\nDar es Salaam, Tanzania"
    },
    {
      icon: "📮",
      title: "Postal Address",
      content: "P.O. Box 78223\nDar es Salaam, Tanzania"
    },
    {
      icon: "🌍",
      title: "Area of Operation",
      content: "National Coverage\nTanzania"
    }
  ];

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Get in Touch</h2>
          <p className="section-subtitle">We're here to help and support you</p>
        </div>
        <div className="contact-content">
          <div className="contact-info">
            {contactInfo.map((info, index) => (
              <div className="contact-item" key={index}>
                <div className="contact-icon">{info.icon}</div>
                <div>
                  <h3>{info.title}</h3>
                  <p>{info.content.split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < info.content.split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="contact-image">
            <img src="/IMG_6339.jpg" alt="Contact Us" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
